import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { Category } from 'src/app/cards/category/category.model';
import { CategoryService } from 'src/app/cards/category/category.service';
import { Globle } from 'src/assets/globle';
import { OrderByCategory } from '../orderByCategory.model';
import { ReportsService } from '../reports.service';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { ExportexcelService } from '../exportexcel.service';

@Component({
  selector: 'app-ordersbycategory',
  templateUrl: './ordersbycategory.component.html',
  styleUrls: ['./ordersbycategory.component.css']
})
export class OrdersbycategoryComponent implements OnInit {

  reports: OrderByCategory[] = [];
  categories: Category[] = [];
  displayedColumns: string[] = ['date', 'subCategory', 'product', 'quantity', "total", "CardsNumber"];
  dataSource!: MatTableDataSource<OrderByCategory>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  @ViewChild('fromDate') fromDate!: ElementRef;
  @ViewChild('toDate') toDate!: ElementRef;
  spinnerOverlay = false;
  selectedCategory!: number;
  lang = 'en';
  reportObj: OrderByCategory = {} as OrderByCategory;
  directCharged = false;
  pageSize = 100;
  breakpoint: number = 0;
  public isMobile: boolean = false;
  constructor(private service: ReportsService,
    private categoryService: CategoryService,
    private translate: TranslateService,
    private excelService: ExportexcelService,
    private globle: Globle) { }

  ngOnInit() {
    this.pageSize = this.globle.pageSize;
    this.breakpoint = (window.innerWidth <= 400) ? 1 : 7;
    this.getCategory();
  }

  getCategory() {
    this.categoryService.getAll(1, this.directCharged).subscribe(data => {
      this.categories = data
    }, error => {
      console.log(error)
    })
  }

  get() {
    this.spinnerOverlay = true;
    this.service.getAllByCategory(this.selectedCategory, this.fromDate.nativeElement.value, this.toDate.nativeElement.value).subscribe(data => {

      this.reports = data;
      //let obj = data

      // this.reports = [];
      // if (obj.length > 0) {

      //   for (let i = 0; i < obj.length; i++) {
      //     this.reportObj = {} as OrderByCategory;
      //     this.reportObj.subCategory = obj[i]['product']['subCategory']['arabicName'];
      //     this.reportObj.product = obj[i]['product']['arabicName'];
      //     this.reportObj.total = obj[i]['total'];
      //     this.reportObj.quantity = obj[i]['quantity'];

      //     var date = new Date(obj[i]['date']);
      //     this.reportObj.date = ((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear() + " " + date.getHours() + ":" + date.getMinutes();
      //     this.reports.push(this.reportObj);
      //   }
      // }
      this.dataSource = new MatTableDataSource(this.reports);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.spinnerOverlay = false;
    },
      error => {
        this.spinnerOverlay = false;
        console.log(error);
        this.reports = [];
        this.dataSource = new MatTableDataSource(this.reports);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      })
  }

  onApply() {
    this.get();
  }

  getTotalCost() {
    return this.reports.map(t => t.total).reduce((acc, value) => acc + value, 0).toFixed(3);
  }

  Print() {

    const doc = new jsPDF({ filters: ["ASCIIHexEncode"] });

    doc.addFileToVFS("../../assets/Amiri/Amiri-Regular.ttf", this.globle.AmiriRegular);
    doc.addFont("../../assets/Amiri/Amiri-Regular.ttf", "Amiri", "normal");

    doc.setFont("Amiri");

    doc.setFontSize(18);
    doc.setTextColor(40);
    //doc.setFont("",'normal');

    doc.text("كشف فئة رئيسية ", 90, 10);
    doc.text("_________________________________", 50, 12);

    // set font
    doc.setFontSize(10);
    doc.viewerPreferences({ "Direction": "L2R" }, true);
    doc.text(" الفئة : " + this.categories.find(x => x.id == this.selectedCategory)?.arabicName, 150, 20, {
      isOutputRtl: true,

    });

    if (this.fromDate.nativeElement.value != null && this.fromDate.nativeElement.value != ""
      && this.toDate.nativeElement.value != null && this.toDate.nativeElement.value != "") {
      doc.text(" من تاريخ : " + this.fromDate.nativeElement.value, 100, 20, {
        isOutputRtl: true
      });
      doc.text(" الى تاريخ : " + this.toDate.nativeElement.value, 50, 20, {
        isOutputRtl: true
      });
    }

    //autoTable({ html: '#orderProductTable', margin: { top: 30 }, styles: { font: "Amiri" } });
    autoTable(doc, { html: '#CatgTable', margin: { top: 30 }, styles: { font: "Amiri" } });
    //doc.save("test.pdf");
    doc.output('dataurlnewwindow');
  }

  exportAsXLSX(): void {
    var exportList = [];
    for (let i = 0; i < this.reports.length; i++) {
      var productCards = "";
      this.reports[i].productCards.forEach((item: any) => {
        productCards += item
      })
      var obj = {
        "التاريخ": this.reports[i].date,
        "الفئة الفرعيه ": this.reports[i].subCategory,
        "المنتج ": this.reports[i].productName,
        "الكمية": this.reports[i].quantity,
        "المجموع": this.reports[i].total,
        "ارقام البطاقات": productCards
      }

      exportList.push(obj);
    }
    this.excelService.exportAsExcelFile(exportList, 'تقرير مبيعات فئة رئيسية');
  }

  onResize(event: any) {
    console.log(event)
    this.breakpoint = (event.target.innerWidth <= 400) ? 1 : 7;
  }

}
